import React from 'react';
import { motion } from 'framer-motion';

const ProgressIndicator = ({ currentStep }) => {
  const steps = [1, 2, 3, 4]; // 4 steps
  const progressWidths = [
    '15%',
    '38.5%', // 1/3 of the total width
    '62.5%', // 2/3 of the total width
    '86%', // full width
    '100%', // full width
  ];

  return (
    <div className="progress-indicator relative flex flex-col items-center gap-8">
      <div className="w-full h-1 bg-purple/50 relative">
        <motion.div
          className="h-full bg-purple"
          initial={{ width: '0%' }}
          animate={{ width: progressWidths[currentStep - 1] }}
          transition={{ duration: 0.5 }}
        ></motion.div>
      </div>
      <div className="progress-steps flex items-center absolute top-0 w-full h-full justify-between max-w-2xl">
        {steps.map((step) => (
          <div key={step} className="flex items-center relative" style={{ width: '20%' }}>
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center font-semibold text-sm leading-normal`}
              style={{
                backgroundColor: step <= currentStep ? '#6B46C1' : 'white',
                color: step <= currentStep ? 'white' : 'black',
                zIndex: 2,
              }}
            >
              <span className="block -mt-0.5">{step}</span>
            </div>
          </div>
        ))}
        <div
          className={`w-8 h-8 rounded-full flex items-center justify-center font-semibold text-sm leading-normal ${
            currentStep === 5 ? 'bg-green text-black' : 'bg-white'
          }`}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={3}
            stroke="currentColor"
            className="size-4"
          >
            <path strokeLinecap="round" strokeLinejoin="round" d="m4.5 12.75 6 6 9-13.5" />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
